import Component from './component.js';

class ModalDialog extends Component {
    constructor() {
        super();
        this.addEventListener('focusout', this.onFocusOut);
        this.addEventListener('keydown', this.onKeyDown);
        this.addEventListener('click', this.onClick);
    }

    connectedCallback() {
        this.role = 'dialog';
        this.ariaModal = 'true';
        this.tabIndex = 0;
    }

    /**
     * @override
     */
    async show() {
        super.show();
        // @ts-ignore
        (this.querySelector('[autofocus]') ?? this).focus();
        this.ownerDocument.documentElement.style.overflow = 'hidden';
        this.dispatch('show');
    }

    /**
     * @override
     */
    hide() {
        super.hide();
        this.ownerDocument.documentElement.style.overflow = null;
        this.dispatch('hide');
    }

    /**
     * @param {FocusEvent & {relatedTarget: Element}} event
     */
    onFocusOut(event) {
        if (!this.contains(event.relatedTarget)) {
            this.focus();
        }
    }

    /**
     * @param {KeyboardEvent} event
     */
    onKeyDown(event) {
        if (event.key.startsWith('Esc')) {
            this.hide();
            this.querySelector('form')?.reset();
        }
    }

    /**
     * @param {MouseEvent & {target: Element}} event
     */
    onClick(event) {
        if (event.target.closest('[class*=close]')) {
            this.hide();
        }
    }
}

customElements.define('modal-dialog', ModalDialog);
export default ModalDialog;
